module.exports = __webpack_public_path__ + "static/media/landscape-mode.9b3d5a9b.webp";